import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_DATA } from '../constants';
import { getSuggestedPeople } from '../helper';

export default function useSuggestedPeopleWidget() {
  return useQuery({
    queryKey: [QUERY_KEY_DATA.suggested],
    queryFn: getSuggestedPeople,
    staleTime: 60 * 1000, // 60 seconds
  });
}
